
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ComingSoonPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen p-4 md:p-6 text-white" style={{ paddingTop: '3rem' }} dir="rtl">
      <div className="max-w-4xl mx-auto px-2 sm:px-4 md:px-0 mt-10 md:mt-0">
        {                                                 }
        <div
          className="relative mb-8 w-full max-w-6xl mx-auto"
          style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px',
            gap: '8px',
            isolation: 'isolate',
            minHeight: 'min(628px,80vh)',
            background:
              'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), radial-gradient(92.12% 184.55% at 50% -55%, rgba(40, 227, 218, 0.2) 0%, rgba(40, 227, 218, 0) 100%), #081423',
            border: '0.924351px solid rgba(40, 227, 218, 0.25)',
            boxShadow: '0px 8px 32px rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(1px)',
            borderRadius: '24px'
          }}
        >
          <div
            className="w-full h-full p-4 sm:p-6"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '24px',
              zIndex: 0
            }}
          >
            {                       }
            <div
              className="w-full flex flex-col items-center justify-center gap-4"
              style={{ textAlign: 'center' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '8px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '16px',
                    gap: '8px',
                    width: '50px',
                    height: '50px',
                    background:
                      'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(17, 101, 97, 0.25)',
                    boxShadow: '0px 8px 32px rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(1px)',
                    borderRadius: '100px'
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 3a9 9 0 1 0 9 9"
                      stroke="#FFFFFF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M12 7v5l3 2"
                      stroke="#FFFFFF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18 3v4"
                      stroke="#28E3DA"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M16 5h4"
                      stroke="#28E3DA"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

                <div
                  style={{
                    fontFamily: 'Alexandria',
                    fontStyle: 'normal',
                    fontWeight: 800,
                    fontSize: '20px',
                    lineHeight: '120%',
                    color: '#FFFFFF'
                  }}
                >
                  قريباً
                </div>
              </div>

              <p
                style={{
                  maxWidth: '480px',
                  fontFamily: 'Alexandria',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '15px',
                  lineHeight: '170%',
                  color: 'rgba(255,255,255,0.85)'
                }}
              >
                هذه الصفحة تحت التطوير حالياً 🤝
                نجهّز لك تجربة مخصصة هنا داخل منصة <span style={{ fontWeight: 700 }}>همة</span>.
                ترقّب قريباً مزايا جديدة متعلقة بحسابك.
              </p>
            </div>

            {                                }
            <div className="mt-6 w-full flex justify-center">
              <button
                onClick={() => navigate('/')}
                className="w-full max-w-xs"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '12px 36px',
                  gap: '8px',
                  background:
                    'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
                  borderRadius: '16px',
                  border: 'none',
                  fontFamily: 'Alexandria',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '100%',
                  textAlign: 'center',
                  color: '#FFFFFF',
                  cursor: 'pointer'
                }}
              >
                الرجوع للصفحة الرئيسية
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
